import type { EventModuleKind } from './const'
import { isProgramItemRegulationModuleSlug } from '~/entities/round-table/program/model/programItemRegulationSlug'
import {
  isEventPassportSlug,
  isEventProgramSlug,
  isEventRegulationSlug,
} from '~/shared/const/workspaceModuleCreate'

export function resolveModuleKindBySlug(
  slug: string | null | undefined,
): EventModuleKind | null {
  if (isEventPassportSlug(slug)) {
    return 'passport'
  }
  if (isEventProgramSlug(slug)) {
    return 'program'
  }
  if (isEventRegulationSlug(slug) || isProgramItemRegulationModuleSlug(slug)) {
    return 'regulation'
  }
  return null
}
